import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getUsersBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const usersItem = {
    label: t('members'),
    path: APP_URLS.dashboard.users.index.getPathWithQuery(),
  };
  const viewUserItem = {
    label: t('view-user'),
    path: APP_URLS.dashboard.users.view.getDynamicPath({
      pathParts: {
        id: `${entity?.id}`,
      },
    }),
  };

  return [
    {
      condition: APP_URLS.dashboard.users.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('members'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.users.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        usersItem,
        {
          label: t('view-personal-info'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.users.viewAccess.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        usersItem,
        viewUserItem,
        {
          label: t('view-access-rights'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.users.editAccess.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [
        dashboardHomeItem,
        usersItem,
        viewUserItem,
        {
          label: t('edit-access-rights'),
        },
      ],
    },
  ];
}
